import { useLingui } from "@lingui/react";

import { $api } from "@/shared/api";

// Описания меняются вместе со справочниками — раз в сутки; за сессию не меняются.
const TOOLTIPS_STALE_TIME_MS = 60 * 60_000;

// Описания предметов магазина на языке интерфейса (`GET /api/matches/item-tooltips`).
// Грузятся при первом нажатии на иконку предмета (`enabled`), потом — из кэша.
export const useItemTooltips = (enabled: boolean) => {
  const { i18n } = useLingui();
  const lang = i18n.locale === "ru" ? "ru" : "en";
  return $api.useQuery(
    "get",
    "/api/matches/item-tooltips",
    { params: { query: { lang } } },
    { staleTime: TOOLTIPS_STALE_TIME_MS, gcTime: Infinity, enabled },
  );
};
